import {
  collection,
  collectionGroup,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { storage } from "config/firebase";
import { db } from "@freetech/models/db";
import {
  Client,
  ConsultingServicesAgreement,
  Project,
} from "@freetech/models/projects";
import { ClientInvoiceData } from "@freetech/models/bank";
import { getDownloadURL, ref } from "@firebase/storage";
import { updateDocument } from "core/firestore";
import { IFeatureRequest } from "@freetech/models";

const filterClientData = <T extends { clientId: string }>(
  data: T[],
  clientId: string
): T[] => {
  return data.filter((item) => item.clientId === clientId);
};

export const loadNestedClients = async (): Promise<Client[]> => {

  const clientsQuery = db.clients;
  const clientsSnapshot = await getDocs(clientsQuery);
  const clients: Client[] = clientsSnapshot.docs.map((doc) => doc.data());

  
  const [projectsSnapshot, csaSnapshot, invoicesSnapshot] = await Promise.all([
    getDocs(db.cg.projects),
    getDocs(db.cg.consultingServicesAgreements),
    getDocs(db.cg.invoices),
  ]);

  const projects = projectsSnapshot.docs.map(doc => doc.data());
  const csaList = csaSnapshot.docs.map(doc => doc.data());
  const invoices = invoicesSnapshot.docs.map(doc => doc.data());

  const featureRequestsSnapshot = await getDocs(query(
    db.featureRequests,
    where(
      "clientId",
      "in",
      clients.map((client) => client.id)
    )
  ));
  const featureRequests = featureRequestsSnapshot.docs.map(doc => ({ ...(doc.data() as IFeatureRequest), id: doc.id }));


  const processedCSAs = await processCSAList(csaList);


  return clients.map((client: Client) => ({
    ...client,
    projects: filterClientData(projects, client.id),
    consultingServicesAgreements: filterClientData(processedCSAs, client.id),
    invoices: filterClientData(invoices, client.id),
    featureRequests: filterClientData(featureRequests, client.id),
  }));
};


const processCSAList = async (
  csaList: ConsultingServicesAgreement[]
): Promise<ConsultingServicesAgreement[]> => {
  const downloadAndSaveCSA = async (
    csa: ConsultingServicesAgreement
  ): Promise<string> => {
    const storageRef = ref(
      storage,
      `clients/${csa.clientId}/consultingServicesAgreements/${csa.id}`
    );
    const downloadUrl = await getDownloadURL(storageRef);

    await updateDocument(
      `clients/${csa.clientId}/consultingServicesAgreements/${csa.id}`,
      { fileUrl: downloadUrl }
    );

    return downloadUrl;
  };
  return Promise.all(
    csaList.map(async (csa) => {
      try {

        const downloadUrl =
          csa.fileUrl === undefined
            ? await downloadAndSaveCSA(csa)
            : csa.fileUrl;

        return { ...csa, fileUrl: downloadUrl };
      } catch (error) {
        console.error("Error getting fileUrl for CSA", error);
        return csa;
      }
    })
  );
};
